import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import Modal from '../../../common/components/organisms/Modal';
import { getAnnotationColor, getAnnotationIcon } from '../utils/annotationPresentation';
import {
  ModalContent,
  HeaderSection,
  IconCircle,
  HeaderText,
  Title,
  Subtitle,
  ContentSection,
  SectionTitle,
  Description,
} from './NoteAnnotationModal.styled';

function formatAnnotationType(type) {
  return type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

const NoteAnnotationModal = ({ annotation, onClose }) => {
  const { t } = useTranslation();
  const typeColor = getAnnotationColor(annotation, { respectSeverity: false });
  const typeIcon = getAnnotationIcon(annotation.type);

  return (
    <Modal
      title={t('annotations.modal.detailsTitle', { type: formatAnnotationType(annotation.type) })}
      close={onClose}
      footer={() => (<button onClick={onClose}>{t('common.close')}</button>)}
    >
      <ModalContent>
        <HeaderSection>
          <IconCircle bg={typeColor}>
            <span aria-hidden="true">{typeIcon}</span>
          </IconCircle>
          <HeaderText>
            <Title>{formatAnnotationType(annotation.type)}</Title>
            <Subtitle>
              {t('annotations.modal.createdBy', {
                timestamp: moment(annotation.created_at).format('MMM DD, YYYY HH:mm'),
                user: annotation.created_by_name || annotation.created_by
              })}
            </Subtitle>
          </HeaderText>
        </HeaderSection>

        <ContentSection>
          <SectionTitle>{t('annotations.modal.sections.description')}</SectionTitle>
          <Description>
            {annotation.description || t('annotations.modal.noDescription')}
          </Description>
        </ContentSection>
      </ModalContent>
    </Modal>
  );
};

NoteAnnotationModal.propTypes = {
  annotation: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
    start_time: PropTypes.string.isRequired,
    end_time: PropTypes.string,
    description: PropTypes.string,
    severity: PropTypes.oneOf(['low', 'medium', 'high', 'critical']),
    created_by: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    created_by_name: PropTypes.string,
    created_at: PropTypes.string,
    source_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    source_type: PropTypes.string,
    base_metadata: PropTypes.object,
    user_metadata: PropTypes.object
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default NoteAnnotationModal;


